export const calendarRef = 'calendar';
export const durationOptions = [
  { value: '', name: '- Select Duration -', disabled: true },
  {
    value: '15_MINS',
    name: '15 Minutes (Fixed)',
  },
  {
    value: '30_MINS',
    name: '30 Minutes (Fixed)',
  },
  {
    value: '60_MINS',
    name: '1 Hour (Fixed)',
  },
];
